import { render, staticRenderFns } from "./Versions.vue?vue&type=template&id=b7e5f572&scoped=true&"
import script from "./Versions.vue?vue&type=script&lang=ts&"
export * from "./Versions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e5f572",
  null
  
)

export default component.exports